'use strict';

// utility class
import ApplyClass from '../util/_apply-class';

import Form from '../controller/_form';
import FormAgreeView from '../view/form/_form-agree-view';
import FormChangeDateView from '../view/form/_form-change-date-view';
import FormSubmitView from '../view/form/_form-submit-view';
import FormValidateView from '../view/form/_form-validate-view';
import FormYearCreateView from '../view/form/_form-year-create-view';

$(() => {
	const FormController = new Form();
	// 規約同意
	$('#agree').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(FormAgreeView, $e, [$e, FormController]);
	});
	// 年月変更
	$('.date').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(FormChangeDateView, $e, [$e]);
	});
	// submit
	$('.btn[type=submit][data-form]').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(FormSubmitView, $e, [$e, FormController]);
	});
	// validate
	$('.validate').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(FormValidateView, $e, [$e, FormController]);
	});
	// 年作成
	$('.input-select__select.year').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(FormYearCreateView, $e, [$e]);
	});
});
